import { factoringSubreducer } from "./factoring/subreducer";
import { smeSubreducer } from "./sme/subreducer";
import { originatorsSubreducer } from "./originator/subreducer";

export let initialState = {
  factoring: {
    invoice: {
      fetching: false,
      fetched: false,
      error: null,
      data: [],
    },
    application: {
      fetching: false,
      fetched: false,
      error: null,
      data: [],
      table: {
        currentFilter: null,
        pagination: { page: 1, take: 10 },
      },
    },
    applicationCreate: {
      sent: false,
      sending: false,
      error: null,
    },
  },
  originators: {
    data: [],
    fetching: false,
    fetched: false,
    error: null,
  },

  SME: {
    invoice: {
      fetching: false,
      fetched: false,
      error: null,
      data: [],
    },
    application: {
      fetching: false,
      fetched: false,
      error: null,
      data: [],
      table: {
        currentFilter: null,
        pagination: { page: 1, take: 10 },
      },
    },
    applicationCreate: {
      sent: false,
      sending: false,
      error: null,
    },
  },
};

const marketplace = (state = initialState, action) => {
  let substate = state;
  substate = factoringSubreducer(substate, action);
  substate = originatorsSubreducer(substate, action);
  substate = smeSubreducer(substate, action);
  return substate;
};

export default marketplace;
